// App-side endpoint map for the Tms API only. Transport (axios, interceptors,
// idempotency, error shaping) lives in @my/platform/http. Directory endpoints
// live in @my/directory-api — import hooks from there, not from here.
//
// As Tms grows we'll likely shape this similarly to @my/directory-api: a
// generated schema + thin typed wrappers + TanStack Query hooks. For Phase 3
// we only need api-info to confirm the gateway routing.
import { request, type ApiInfo } from '@my/platform/http';

/** Endpoints scoped to the Tms API (`/tms/api/v1/*`). */
export const Tms = {
  getApiInfo: () => request.get<ApiInfo>('/tms/api/v1/info/api-info'),
};

export const agent = { Tms };
export type { ApiInfo };
